export class EventEmitter {
	// Map of event name to listener array
	private listeners: Map<string, Function[]> = new Map();

	/** Emits event with payload */
	public emit(event: string, payload: any = undefined) {
		(this.listeners.get(event) || []).forEach(fn => fn(payload))
	}

	/** Unregister listener from event */
	public off(event: string, fn: Function) {
		const fns = this.listeners.get(event) || [];
		this.listeners.set(event, fns.filter(f => f!=fn));
	}

	/** Register listener to event */
	public on(event: string, fn: Function) {
		const fns = this.listeners.get(event) || [];
		fns.push(fn);
		this.listeners.set(event, fns);
	}
}
